const variantClasses = {
  primary:   'bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700 focus:ring-primary-500 dark:bg-primary-600 dark:hover:bg-primary-500 shadow-clay-btn dark:shadow-clay-btn-dark',
  secondary: 'bg-secondary-500 text-white hover:bg-secondary-600 active:bg-secondary-700 focus:ring-secondary-500 dark:bg-secondary-600 dark:hover:bg-secondary-500 shadow-clay-btn dark:shadow-clay-btn-dark',
  success:   'bg-success-500 text-white hover:bg-success-600 active:bg-success-700 focus:ring-success-500 dark:bg-success-600 dark:hover:bg-success-500 shadow-clay-btn dark:shadow-clay-btn-dark',
  danger:    'bg-danger-500 text-white hover:bg-danger-600 active:bg-danger-700 focus:ring-danger-500 dark:bg-danger-600 dark:hover:bg-danger-500 shadow-clay-btn dark:shadow-clay-btn-dark',
  ghost:     'bg-white/70 dark:bg-white/8 text-neutral-700 dark:text-neutral-300 hover:bg-white dark:hover:bg-white/12 focus:ring-neutral-400 shadow-clay-btn dark:shadow-clay-btn-dark',
  outline:   'bg-white/70 dark:bg-transparent border border-neutral-200 dark:border-white/15 text-neutral-700 dark:text-neutral-300 hover:bg-white dark:hover:bg-white/8 focus:ring-neutral-400 shadow-clay-btn dark:shadow-clay-btn-dark',
};

const sizeClasses = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-base',
  xl: 'px-6 py-3 text-lg',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  children,
  ...props
}) {
  return (
    <button
      className={[
        'inline-flex items-center justify-center font-medium rounded-clay-sm transition-all duration-150',
        'focus:outline-none focus:ring-2 focus:ring-offset-2',
        'focus:ring-offset-white dark:focus:ring-offset-[#0d0f1a]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'active:translate-y-px active:shadow-clay-btn-press',
        variantClasses[variant],
        sizeClasses[size],
        className,
      ].join(' ')}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
